<template>
  <div class="container" >
     <PayrollTable></PayrollTable>
  </div>
</template>

<script>
import PayrollTable from './components/PayrollTable.vue'
export default {
  components: { PayrollTable},
  data() {
    return {
    };
  },
  watch:{
  },
  created(){
  },
  mounted(){
  },
  methods: {
  },
};
</script>

<style lang="less" scoped>

/deep/ .el-tabs {
  height: 100%;
}
/deep/ .el-tabs__content {
  height: calc(100% - 40px);
}
.container {
  // height: calc(100% - 20px);
  background-color: white;
  padding: 20px;
  box-sizing: border-box;
  .greenText,.search {
    background: #269d7b;
    color: #fff;

  }
  .search{
     border-radius: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/salary/payroll.vue